"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const cootsHeight = 19;
exports.default = cootsHeight;
